import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))
const RiskDetail = lazy(() => import('./risks/Detail'))

//	///////////////////////
//	MARK: EXPORTS
/**
 * ★ Hazard & Risk Register — `03` §3.1.
 *
 * <p><b>Les fiches portent un préfixe statique, les onglets prennent le reste.</b> `Index` monte
 * `RouterTabs` en mode routes : quand le segment restant est vide, il navigue vers le premier
 * onglet (`register`). Avec une route `:hazardId/*` au même niveau, `/safety/hazards/register`
 * tombait sur la fiche avec `hazardId = 'register'` — `Number('register')` vaut `NaN`, la clé SWR
 * devenait `false`, et le registre affichait un squelette sans fin sans jamais appeler l'API.
 *
 * <p>Un segment statique bat toujours `:param` en react-router v6, et un `*` nu perd contre
 * `:hazardId/*` : préfixer les fiches est la seule répartition qui marche sans toucher au
 * composant partagé `RouterTabs`.
 */
export const SafetyHazardRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--hazards']}>
    <Route path='risks/:riskId/*' element={<RiskDetail />} />
    <Route path='hazard/:hazardId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
